module.exports = __webpack_public_path__ + "img/Andaluza-29-min.fe88eda5.jpg";